export function computeStatusDefault(state: string) {
  switch (state) {
    case 'SUCCESS:1':
    case 'SUCCESS:2':
    case 'SUCCESS:3':
    case 'PENDING:2':
      return 'PROCESSING';
    case 'SUCCESS':
    case 'SUCCESS:4':
      return 'SUCCESS';
    case 'PENDING:1':
      return 'PENDING';
    default:
      return state;
  }
}

export function computeStatusWithCode(state: string) {
  const newState = computeStatusDefault(state);
  if (newState.indexOf('FAILURE') >= 0) {
    const pos = newState.indexOf(';SRC=');
    if (pos >= 0) {
      return newState.substring(0, pos);
    }
  }

  if (newState.indexOf('PENDING') >= 0) {
    const pos = newState.indexOf(';');
    if (pos >= 0) {
      return newState.substring(0, pos);
    }
  }

  if (newState.indexOf('PROCESSING') >= 0) {
    const pos = newState.indexOf(';');
    if (pos >= 0) {
      return newState.substring(0, pos);
    }
  }

  const pos = newState.indexOf(';DATA=');
  if (pos >= 0) {
    return newState.substring(0, pos);
  }

  return newState;
}

export function computeStatusSpOdToGraph(state: string) {
  return state === 'SUCCESS:1' ? 'PENDING' : computeStatusWithCode(state);
}

export function computeStatusExchangeMail(isProvision: boolean, state: string) {
  switch (state) {
    case 'SUCCESS:1':
    case 'SUCCESS:2':
    case 'SUCCESS:3':
      return 'PENDING';
    case 'FAILURE:1':
    case 'FAILURE:2':
    case 'FAILURE:3':
      return 'FAILURE';
    default:
      return isProvision
        ? computeStatusWithCode(state)
        : computeStatusDefault(state);
  }
}

export function computeStatusExchangeInline(state: string, statuses: any[]) {
  switch (state) {
    case 'SUCCESS:1':
    case 'SUCCESS:2':
    case 'SUCCESS:3':
      return 'PENDING';
    case 'FAILURE:1':
    case 'FAILURE:2':
    case 'FAILURE:3':
      return 'FAILURE';
    default:
      for (const status of statuses) {
        if (
          status.type === 'GRAPH_EX_INLINE_ACCOUNT_AUTO_PROVISION' &&
          status.value !== 'SUCCESS'
        ) {
          return status.value;
        }
      }
      return computeStatusDefault(state);
  }
}
